import { useRef, useEffect, RefObject } from 'react';

interface UseScrollRestorationOptions {
  containerRef: RefObject<HTMLDivElement | null>;
  dataLength: number;
  offsetHeight?: number;
}

export const useScrollRestoration = ({
  containerRef,
  dataLength,
  offsetHeight = 100,
}: UseScrollRestorationOptions) => {
  const previousScrollHeightRef = useRef<number>(0);

  const saveScrollPosition = () => {
    const scrollContainer = containerRef.current?.querySelector(
      '[data-testid="scrollable-container"]',
    ) as HTMLDivElement;

    if (scrollContainer) {
      previousScrollHeightRef.current = scrollContainer.scrollHeight;
    }
  };

  // Restore scroll position after data update
  useEffect(() => {
    if (previousScrollHeightRef.current > 0) {
      const scrollContainer = containerRef.current?.querySelector(
        '[data-testid="scrollable-container"]',
      ) as HTMLDivElement;

      if (scrollContainer) {
        const newScrollHeight = scrollContainer.scrollHeight;
        const heightDifference = newScrollHeight - previousScrollHeightRef.current;

        // Adjust scroll to show that content was loaded
        scrollContainer.scrollTop = heightDifference - offsetHeight;
        previousScrollHeightRef.current = 0;
      }
    }
  }, [dataLength, containerRef, offsetHeight]);

  return { saveScrollPosition };
};
